export const Sections = [
    { id: 1, title: "personalInformation" },
    { id: 2, title: "incomeDetails" },
    { id: 3, title: "investmentPreference" },
    { id: 4, title: "bankDetails" },
    { id: 5, title: "politicalPosition" },
    { id: 6, title: "fatca" },
    { id: 7, title: "reportableJurisdiction" }, 
];

export const PreferenceCommunicationList = [
    { id: 1, title: "Email" },
    { id: 2, title: "SMS" },
    { id: 3, title: "Recorded Phone Call" }, 
];

export const kuwaitPhoneNumberRegex = /^(?:41\d{6}|[569]\d{7})$/;
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const websiteRegex = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/;
export const kuwaitPhoneNumberDigits = 8;
export const passwordCharactersMinimum = 8;
export const civilIdCharactersMinimum = 12;

export const Uppercase = /[A-Z]/;
export const Lowercase = /[a-z]/;
export const Numbercase = /\d/;
export const DigitsOnly = /^\d{12}$/;
export const SpecialChar = /[@#$%^&*(),.?":{}|<>]/;
  